import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { formatDateTime } from './utils/date'
import './assets/styles/global.scss'

Vue.use(ElementUI, { size: 'medium' })
Vue.filter('dateTime', formatDateTime)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
